import { render, staticRenderFns } from "./SvgLogo.vue?vue&type=template&id=c1f6123e&"
import script from "./SvgLogo.vue?vue&type=script&lang=js&"
export * from "./SvgLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports